import React, { useEffect, useRef, useState } from "react";
import { Button, Form, FormLabel } from "react-bootstrap";
import {
  create_faq_question,
  get_collectibles_shipping_content,
  upload_cms_photo,
} from "../../reduxData/cms/cmsAction";
import { FormControl, Input, Textarea } from "@mui/joy";
import { connect, useDispatch } from "react-redux";

const CollectiblesShipping = ({ collectiblesShippingCont }) => {
  const [formData, setFormData] = useState({
    headerImage: "",
    title: "",
    subtitle: "",
    benefits: [
      { icon: "", title: "", text: "" },
      { icon: "", title: "", text: "" },
      { icon: "", title: "", text: "" },
      { icon: "", title: "", text: "" },
    ],
  });
  const dispatch = useDispatch();
  const imageRef = useRef();
  const benefitIconRefs = useRef([]);

  useEffect(() => {
    get_collectibles_shipping_content(
      localStorage.getItem("token"),
      "why_us_shipping",
      dispatch
    );
  }, [dispatch]);

  useEffect(() => {
    if (collectiblesShippingCont && collectiblesShippingCont.length > 0) {
      const content = collectiblesShippingCont[0].content;
      const benefits = (content.benefits || []).slice(0, 4);
      while (benefits.length < 4) {
        benefits.push({ icon: "", title: "", text: "" });
      }
      setFormData({
        headerImage: content.headerImage || "",
        title: content.title || "",
        subtitle: content.subtitle || "",
        benefits: benefits,
      });
    }
  }, [collectiblesShippingCont]);

  const handleImageUpload = async (file) => {
    if (!file) return null;
    const photoData = await upload_cms_photo(
      [file],
      localStorage.getItem("token"),
      dispatch
    );
    return photoData?.data?.photos?.[0] || null;
  };

  const handleHeaderImageChange = async (e) => {
    const imageUrl = await handleImageUpload(e.target.files[0]);
    if (imageUrl) {
      setFormData({ ...formData, headerImage: imageUrl });
    }
  };

  const handleBenefitIconChange = async (e, index) => {
    const iconUrl = await handleImageUpload(e.target.files[0]);
    if (iconUrl) {
      const newBenefits = [...formData.benefits];
      newBenefits[index].icon = iconUrl;
      setFormData({ ...formData, benefits: newBenefits });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBenefitChange = (index, field, value) => {
    const newBenefits = [...formData.benefits];
    newBenefits[index][field] = value;
    setFormData({ ...formData, benefits: newBenefits });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const content_data = {
      name: "why_us_shipping",
      type: "why_us_shipping",
      content: formData,
    };
    const contentId = collectiblesShippingCont?.[0]?._id;
    await create_faq_question(
      localStorage.getItem("token"),
      content_data,
      contentId,
      dispatch
    );
  };

  return (
    <div>
      <div className="container">
        <h3 className="mb-2 fw-600">"Why Us?" Shipping Page Content</h3>
      </div>
      <Form onSubmit={handleSubmit}>
        <div className="ms-2 p-2">
          <FormControl className="mt-0 mb-3">
            <FormLabel className="fw-600">Header Image</FormLabel>
            {formData.headerImage && (
              <img
                src={formData.headerImage}
                alt="Header"
                style={{ width: "100%", maxHeight: "200px", objectFit: "cover", marginBottom: "1rem" }}
              />
            )}
            <input
              type="file"
              className="d-none"
              accept="image/*"
              ref={imageRef}
              onChange={handleHeaderImageChange}
            />
            <Button className="btn upload-button" onClick={() => imageRef.current.click()}>
              Upload Header Image
            </Button>
          </FormControl>

          <FormControl className="mt-0 mb-3">
            <FormLabel className="fw-600">Title</FormLabel>
            <Input
              type="text"
              name="title"
              placeholder="e.g., The InsertBid Shipping Difference"
              value={formData.title}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl className="mt-0 mb-3">
            <FormLabel className="fw-600">Subtitle</FormLabel>
            <Input
              type="text"
              name="subtitle"
              placeholder="e.g., Peace of mind for your prized collectibles..."
              value={formData.subtitle}
              onChange={handleChange}
            />
          </FormControl>

          <h4 className="mt-4">Benefits Section</h4>
          <hr />
          
          <div className="row">
            {formData.benefits.map((benefit, index) => (
              <div key={index} className="col-md-6 mb-3">
                <div className="p-3 border rounded">
                  <h5 className="mb-2">{`Benefit ${index + 1}`}</h5>
                  <FormControl className="mt-0 mb-2">
                    <FormLabel className="fw-600">Benefit Icon</FormLabel>
                    {benefit.icon && (
                       <img src={benefit.icon} alt="Benefit Icon" style={{ width: "50px", height: "50px", objectFit: "contain", marginBottom: "1rem", background: "#f0f0f0", padding: "5px", borderRadius: "5px" }} />
                    )}
                    <input
                      type="file"
                      className="d-none"
                      accept="image/*,.svg"
                      ref={el => benefitIconRefs.current[index] = el}
                      onChange={(e) => handleBenefitIconChange(e, index)}
                    />
                    <Button size="sm" className="btn upload-button" onClick={() => benefitIconRefs.current[index].click()}>
                      Upload Icon
                    </Button>
                  </FormControl>
                  <FormControl className="mt-0 mb-2">
                    <FormLabel className="fw-600">Benefit Title</FormLabel>
                    <Input
                      type="text"
                      placeholder="e.g., Fully Insured"
                      value={benefit.title}
                      onChange={(e) => handleBenefitChange(index, "title", e.target.value)}
                    />
                  </FormControl>
                  <FormControl className="mt-0 mb-2">
                    <FormLabel className="fw-600">Benefit Text</FormLabel>
                    <Textarea
                      minRows={3}
                      placeholder="Enter the description for this benefit..."
                      value={benefit.text}
                      onChange={(e) => handleBenefitChange(index, "text", e.target.value)}
                    />
                  </FormControl>
                </div>
              </div>
            ))}
          </div>

          <Button type="submit" className="btn common-button mt-3">
            Save Changes
          </Button>
        </div>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    collectiblesShippingCont: state.cms.collectiblesShippingCont,
  };
};

export default connect(mapStateToProps)(CollectiblesShipping);